const settings = {
    defaultLanguage: 'ro',
    API_URL: 'https://apibcmag.zootzle.com/',
    API_ENDPOINT_FILE: 'file?path=',
    API_ENDPOINT_REGISTER_YEAR: 'users/register/years',
    API_ENDPOINT_LOGIN: 'users/login',
    API_ENDPOINT_REGISTER:'users/register',
    API_ENDPOINT_COUNTIES: 'art/counties',
    API_ENDPOINT_ADDRESS: 'art/address',
    API_ENDPOINT_SHOPPINGCART_MERGE: 'bcmag/shoppingcart/merge/',
    API_ENDPOINT_SHOPPINGCART_TOTAL: 'bcmag/shoppingcart/total/',
    API_ENDPOINT_SHOPPINGCART: 'art/shoppingcart',
    API_ENDPOINT_ORDER: 'bcmag/order/',
    API_ENDPOINT_SHOPPINGCARTITEMS: 'bcmag/shoppingcartitems/',
    API_ENDPOINT_PRODUCTS: "bcmag/products",
    API_ENDPOINT_UPDATE_PROFILE: 'account',
    API_ENDPOINT_SHOPPINGCART_TOTAL: 'bcmag/shoppingcart/total/',
    API_ENDPOINT_DELIVERY_METHODS: 'art/delivery/methods',
    SETTING_ACCESS_LEVEL_ORDER_PROCESSER: 98,
    API_ENDPOINT_ORDERS: 'bcmag/orders',
    API_ENDPOINT_ORDERS_STATUSES: 'art/orders/statuses',
    API_ENDPOINT_ORDERS_INVOICE_ADDRESS: "art/order/invoice/address/",
    API_ENDPOINT_ORDERS_DELIVERY_ADDRESS: "art/order/delivery/address/",
    API_ENDPOINT_ORDER_ITEMS: 'bcmag/orders/items/',
    API_ENDPOINT_USER_FIRMS: 'bcmag/user/firms',
    API_ENDPOINT_FIRMS: 'bcmag/firms',
    API_ENDPOINT_PUT_FIRMS: 'bcmag/firms/',
    API_ENDPOINT_USER_ORDERS: 'art/orders/user',
    API_ENDPOINT_ORDER: 'art/order/',
    API_ENDPOINT_POST_ORDER: 'bcmag/order/',
    API_ENDPOINT_USER_ORDER_INVOICE_ADDRESS: 'art/user/order/invoice/address/',
    API_ENDPOINT_USER_ORDER_DELIVERY_ADDRESS: 'art/user/order/delivery/address/',
    API_ENDPOINT_ORDER_INFORMATION: 'bcmag/orders/information/',
    API_ENDPOINT_COMPATIBLE_PRODUCTS: 'bcmag/compatible/products',
    API_ENDPOINT_COMPATIBLE_PRODUCTS_PRODUCT: 'bcmag/compatible/products/product',
    API_ENDPOINT_COMPATIBLE_PRODUCTS_IMAGES: 'bcmag/compatible/products/images/'
}

export default settings;